import React from "react";
import { CustomLabel } from "../../Constant";
import CustomStepper from "../../elements/CustomStepper";

const StepperComponent = ({ label, ...props }) => {
  return (
    <div className="row my-1">
      <div className="mb-2">
        <CustomLabel font_size='14'>{label}</CustomLabel>
      </div>
      <div className="">
        <CustomStepper {...props}/>
      </div>
    </div>
  );
};

export default StepperComponent;
